export default "__VITE_ASSET__DtlCJFFM__"